var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoresactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stores_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12750",
    transform: "translate(23012 13909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-22972.6-13897.1h-33.5c-0.9,0-1.7-0.8-1.7-1.7v-1.7c0-3.8,3.1-6.9,6.9-6.9h23.2c3.8,0,6.9,3.1,6.9,6.9v1.7 C-22970.9-13897.9-22971.7-13897.1-22972.6-13897.1z M-23004.4-13900.6h30.1c0-1.9-1.5-3.4-3.4-3.4h-23.2 C-23002.9-13904-23004.4-13902.5-23004.4-13900.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-22972.6-13864.6h-33.5c-0.9,0-1.7-0.8-1.7-1.7v-25.7c0-0.9,0.8-1.7,1.7-1.7h33.5c0.9,0,1.7,0.8,1.7,1.7 v25.7C-22970.9-13865.3-22971.7-13864.6-22972.6-13864.6z M-23004.4-13868h30.1v-22.3h-30.1V-13868z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-22984.7-13864.6h-10.3c-0.9,0-1.7-0.8-1.7-1.7v-15.4c0-1.9,1.5-3.4,3.4-3.4h6.9c1.9,0,3.4,1.5,3.4,3.4v15.4 C-22983-13865.3-22983.8-13864.6-22984.7-13864.6z M-22993.3-13868h6.9v-13.7h-6.9L-22993.3-13868z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4332_00000168081778429508864510000018137331651295023765_",
    className: "st0",
    d: "M-23008.7-13898.9h39.4 c0.9,0,1.7,0.8,1.7,1.7v3.4c0,0.9-0.8,1.7-1.7,1.7h-39.4c-0.9,0-1.7-0.8-1.7-1.7v-3.4 C-23010.4-13898.1-23009.7-13898.9-23008.7-13898.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-22969.3-13890.3h-39.4c-1.9,0-3.4-1.5-3.4-3.4v-3.4c0-1.9,1.5-3.4,3.4-3.4h39.4c1.9,0,3.4,1.5,3.4,3.4v3.4 C-22965.9-13891.8-22967.4-13890.3-22969.3-13890.3z M-23008.7-13897.1L-23008.7-13897.1v3.4h39.4v-3.4H-23008.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoresactive);
export default __webpack_public_path__ + "static/media/Stores active.3f8cfcd4568b799f070875744a8619fe.svg";
export { ForwardRef as ReactComponent };